/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { TsriEndpointResolver } from "./TsriEndpointResolver";
